import { AddonSelection } from "../../../../components/AddonSelection";

export const AddonsTab = () => {
  return <AddonSelection />;
};
